import { useIsAdmin } from '@atlassian/jira-tenant-context-controller/src/components/is-admin/index.tsx';
import { useAppEditions } from '@atlassian/jira-tenant-context-controller/src/components/app-editions/index.tsx';
import { FREE_EDITION } from '@atlassian/jira-shared-types/src/edition.tsx';
import {
	useIsSimplifiedProject,
	useProjectContext,
} from '@atlassian/jira-providers-project-context/src/index.tsx';

// TODO: rename files
/**
 * We want to show the extended share dialog when the following conditions are met:
 * - All nav4 views OR board/backlog/timeline/issue views in nav3 for TMP
 * - Project is a software or business project with a non-free edition
 * - User is a Jira admin or project admin
 *
 * @returns {boolean} True if the extended share dialog can be shown, false otherwise.
 */
export const useMaybeCanSeeExtendedShareDialog = (): boolean => {
	const isAdmin = useIsAdmin();
	const { data: projectContextData } = useProjectContext();
	const isProjectAdmin = !!projectContextData?.isProjectAdmin;
	const isTMP = useIsSimplifiedProject();
	const appEditions = useAppEditions();

	const projectType = projectContextData?.projectType;
	const isSoftware = projectType === 'software' && appEditions?.software !== FREE_EDITION;
	const isBusiness = projectType === 'business' && appEditions?.core !== FREE_EDITION;

	return (isSoftware || isBusiness) && isTMP && (isAdmin || isProjectAdmin);
};
